import { ref, onValue, getDatabase } from "firebase/database";
import { QueryKeys } from "./query-client";
import { useQuery } from "react-query";
import { useRouter } from "next/router";
import * as firebase from "firebase/app";
import { firebaseConfig } from "../../constants/env";

export interface PartnershipData {
  image: string;
  title: string;
  content: string;
  published: boolean;
}

export function usePartnershipList() {
  const router = useRouter();

  if (!firebase.getApps().length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.getApp(); // if already initialized, use that one
  }
  const database = getDatabase(firebase.getApp());

  const publishedPartnershipsRef = ref(
    database,
    `published/partnerships/${router.locale}`
  );
  const {
    data: partnerships,
    isFetching: partnershipsAreLoading,
    isError: partnershipsError,
  } = useQuery([QueryKeys.PARTNERSHIPS, router.locale], () => getEntries(), {
    keepPreviousData: true,
    retry: 2,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
  });

  // wrap blog entries subscription into a promise to be used with react-query
  function getEntries(): Promise<Record<string, PartnershipData> | null> {
    return new Promise((resolve, reject) => {
      onValue(
        publishedPartnershipsRef,
        async (snapshot) => {
          const publishedEntries: Record<string, PartnershipData> =
            snapshot.val();
          console.log(publishedEntries);
          resolve(publishedEntries);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  function move(from: number, to: number, arr: any[]) {
    const newArr = [...arr];

    const item = newArr.splice(from, 1)[0];
    newArr.splice(to, 0, item);

    return newArr;
  }

  return { partnerships, partnershipsAreLoading, partnershipsError, move };
}
